import CustomDialog from '../../../../../components/stateless/dialog/CustomDialog';
import { AppUser } from '../../../../../utilities/interfaces/AppUser';
import RoleTable from '../../../../../components/stateful/roleTable/RoleTable';
import {useEffect, useState} from "react";
import {GenerateRolesColumnDefinition} from "../../../../../components/stateful/table/TableHelper";

interface Props {
  appUser: AppUser | undefined;
  open: boolean;
  toggleDialog: () => void;
  title: string | undefined;
  columnHeader: string[],

  type: string,
  currentColumnData?: any,
  availableColumnData?: any,

  createFunction: (roleName: any) => void;
  deleteFunction: (roleName: any) => void;
}



const EditAppUserModal = ({
  appUser,
  open,
  toggleDialog,
  createFunction, currentColumnData, availableColumnData,
  deleteFunction, columnHeader, type
}: Props) => {

  const title: string = "Updating " + type + " for User: "+appUser?.email;

  const [columnData, setColumnData] = useState<any>([]);

  useEffect(() => {
    generateColumnData();
  }, []);

  const generateColumnData = async () => {
    let columns = await GenerateRolesColumnDefinition();
    setColumnData(columns);
  };

  return (
    <CustomDialog open={open} title={title} toggleDialog={toggleDialog} hideButtons size='large'>
      {currentColumnData && availableColumnData ? (
          <div className='modify-app-user-roles'>
            <div className='column'>
              <RoleTable
                  type='delete'
                  values={currentColumnData}
                  columns={columnData}
                  userId={appUser!.id}
                  height='40vh'
                  modifyAppUserRole={deleteFunction}
                  columnHeader={columnHeader}
              ></RoleTable>
            </div>
            <div className='column'>
              <RoleTable
                  type='add'
                  values={availableColumnData}
                  columns={columnData}
                  userId={appUser!.id}
                  height='40vh'
                  modifyAppUserRole={createFunction}
                  columnHeader={columnHeader}
              ></RoleTable>
            </div>
          </div>
      ) : null}
    </CustomDialog>
  );
};

export default EditAppUserModal;
